import {crc32} from '@allex/crc32'
import {hasMatch, score as fzyScore} from 'fzy.js'

export interface Icon {
  type: string
  id?: string
  url?: string
  alt?: string
}

export interface ItemData {
  title: string
  priority: number
  group: string
  subtitle?: string
  matchFields?: string[]
  typeahead?: string
  hint?: string
  icon?: Icon
  readonly path?: string
}

export function getItemMatchingFields(item: {title: string; matchFields?: string[] | null}): string[] {
  return item.matchFields ? item.matchFields : [item.title]
}

export function getDefaultItemKey(item: Pick<ItemData, 'title' | 'group' | 'subtitle' | 'matchFields'>): string {
  return `${item.title}-${item.group}-${item.subtitle}-${item.matchFields?.join('-')}`
}

export function getItemId(key: string): string {
  return crc32(key).toString()
}

export function calculateItemScore(matchingFields: readonly string[], queryText: string): number {
  const scores = matchingFields.map(field => (hasMatch(queryText, field) ? fzyScore(queryText, field) : -Infinity))
  return Math.max(...scores)
}

export function filterItemsByScore<T>(
  items: T[],
  isBlank: boolean,
  calculateScore: (item: T) => number,
  minScore = 0,
): T[] {
  if (isBlank) {
    return items
  }

  const matchingItems: T[] = []
  for (const item of items) {
    if (calculateScore(item) > minScore) {
      matchingItems.push(item)
    }
  }

  return matchingItems
}

export function getStaticItemPriority(itemCount: number, index: number): number {
  return itemCount - index
}
